import { render, staticRenderFns } from "./danger.vue?vue&type=template&id=7f243f24&"
import script from "./danger.vue?vue&type=script&lang=js&"
export * from "./danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports